import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import AboutLogos from "../AboutLogos"
import cx from "classnames"
import LogoNerdWallet from "../../../logos/NerdWallet"
import * as React from "react"

const AboutBetter: React.FC = () => {
  const [ref, inView] = useInView({
    threshold: 0,
  })

  return (
    <section
      className={cx({
        [styles.aboutBetter]: true,
        [styles.pictureRight]: true,
      })}
    >
      <div className={styles.pagePadding}>
        <div className={styles.nerdwallet}>
          <div
            className={cx({
              [styles.nerdwalletLogo]: true,
              [styles.inView]: inView,
            })}
            ref={ref}
          >
            <LogoNerdWallet />
          </div>
          <div className={styles.nerdwalletMessage}>
            <p className={styles.nerdwalletEyebrow}>
              Nerdwallet Awards 2018 Winner
            </p>
            <h4 className={styles.nerdwalletHeading}>
              Best Online Mortgage Lenders for Customer Service
            </h4>
          </div>
        </div>
        <div className={styles.message}>
          <div className={styles.header}>
            <h2 className={styles.heading}>We're Better</h2>
          </div>
          <div className={styles.body}>
            <p className={styles.paragraph}>
              Better Mortgage is a direct lender with over $1B in funded home
              loans. We’re transforming homeownership from a one-time purchase
              to a lifelong, evolving investment. With our automated mortgage
              process and the help of companies like Tesla, we provide unique
              products that help customers make the most of their mortgage.
            </p>
          </div>
          <AboutLogos inView={inView} />
        </div>
      </div>
    </section>
  )
}

export default AboutBetter
